import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import * as RestService from '../../services/eisRest';
import DocumentListTab  from '../../modules/document/DocumentListTab';
import DocumentTab  from '../../modules/document/DocumentTab';
import AdditionalInfoTab  from '../../modules/document/AdditionalInfoTab';
import FileTab from '../../modules/file/FileTab';


const Document = (props) => {

    const [activeTab, setActiveTab] = useState('LIST');
    const [t] = useTranslation();
    const [document, setDocument] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [entitySubName, setEntitySubName] = useState();
    const [entitySpecify, setEntitySpecify] = useState();
    const [checkTime, setCheckTime] = useState();
    

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {      
        setEntitySubName(props.entitySubName);
        let defaultSpecify='';
        switch(props.entitySubName){
            case "warehouse":
                defaultSpecify='WRH-RCT';        
            break;
            case "order":          
                defaultSpecify='ORD-RCT';
            break;
            case "invoice":                
                defaultSpecify='INV-RCT';
            break;
            case "deliveryNote":          
                defaultSpecify='DLN-RCT';  
            break;
            default:
        }
        setEntitySpecify(defaultSpecify);
    }, [props.entitySubName])
  

    const handleLoadedDocument = (document) => {
        setDocument(document);
        setCheckTime(Date.now());
    }

    const handleDocumentSelected = (entitySubName,entitySpecify,id,newDoc) => {
            //console.log(entitySpecify)
            setEntitySpecify(entitySpecify);


          
            RestService.callAnyApi('document/getDocument?entitySubName='+entitySubName+"&entitySpecify="+entitySpecify+"&id="+id, null)
                    .then((data) => {
                         setDocument(data);   
                         if(data.id!=null && data.id!==''){
                            setSelectedRecord(id);
                            setActiveTab('DOCUMENT');                            
                         }else{
                            setSelectedRecord(Date.now());
                            if(newDoc){
                                setActiveTab('DOCUMENT');  
                            }
                         }
                        
                    })
                    .catch((error) => {    
                      toast.error(error);
                    });                  
    }

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('document.label.'+entitySubName)}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('document.label.invoicing')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('document.label.'+entitySubName)}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LIST'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        {
                                                            toggle('LIST');                                                                                                                        
                                                        }
                                                    }
                                                >
                                                    {t('document.label.list')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DOCUMENT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DOCUMENT')
                                                    }
                                                >
                                                    {t('document.label.document')}
                                                </button>
                                            </li>                                          
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'ADD_INFO'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('ADD_INFO')
                                                    }
                                                >
                                                    {t('document.label.addInfo')}
                                                </button>
                                            </li>             
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'FILES'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('FILES')
                                                    }
                                                >
                                                    {t('file.label.files')}
                                                </button>
                                            </li>             
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <DocumentListTab
                                                entitySubName={entitySubName}
                                                isActive={activeTab === 'LIST'}  
                                                parentCallback={handleDocumentSelected}
                                                checkTime={checkTime}      
                                            />                                                                                                                                                                           
                                            <DocumentTab
                                                entitySubName={entitySubName}
                                                entitySpecify={entitySpecify}
                                                isActive={activeTab === 'DOCUMENT'}  
                                                selectedRecord={selectedRecord}
                                                parentCallback={handleLoadedDocument}
                                            />  
                                            <AdditionalInfoTab
                                                entitySubName={entitySubName}
                                                entitySpecify={entitySpecify}
                                                isActive={activeTab === 'ADD_INFO'}  
                                                selectedRecord={selectedRecord}
                                                document={document}
                                                //parentCallback={handleDocumentSelected}
                                            />    
                                            <FileTab
                                                isActive={activeTab === 'FILES'}
                                                entityId={document ? document.id : ''}                                                                                                                                                                                               
                                            />                                                                                                                                                                      
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default Document;